'use client';

import {useEffect, useState} from 'react';

import {BodyText} from '@/components/Text';

export default function RegionSwitcherLink() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  if (window.location.hostname.startsWith('eu.')) {
    return null;
  }

  return (
    <BodyText>
      EU region customer? <a href="https://eu.dagster.cloud/">Sign in here</a>
    </BodyText>
  );
}
